import {useHistory} from 'react-router-dom';
import PrimaryButton from '../StyledComponents/PrimaryButton';
import StandardDialog from '../StyledComponents/StandardDialog';
import {Grid, Typography} from '@mui/material';
import {useRecoilValue} from 'recoil';
import {userState} from '../../recoil/user/userAtom';
import SecondaryButton from '../StyledComponents/SecondaryButton';

export default function ProUpgradePopup() {
  const history = useHistory();
  const user = useRecoilValue(userState);

  const getPopupBody = () => {
    switch (user?.servicePlan) {
      case 'FREE':
        return (
          <>
            <Typography variant="h6" lineHeight={1.3} textAlign="center" my={5}>
              Effective May 1, access to Bidmii's contractor features will
              require an active subscription to <b>Bidmii Pro</b>.
              <br />
              <br />
              To continue using these tools, please ensure your subscription is
              up to date.
            </Typography>

            <PrimaryButton
              size="large"
              onClick={() => history.push('/bidmii-pro/checkout')}>
              UPGRADE TO PRO
            </PrimaryButton>
          </>
        );
      case 'PENDING':
        return (
          <>
            <Typography variant="h6" lineHeight={1.3} textAlign="center" my={5}>
              Your <b>Bidmii Pro</b> Scholarship application is currently under
              review.
              <br />
              <br />
              In the meantime, we encourage you to update your profile to better
              highlight your experience and qualifications. A strong, complete
              profile can significantly improve your chances of being selected.
            </Typography>

            <PrimaryButton
              size="large"
              onClick={() => history.push('/my/profile/dashboard')}>
              EDIT MY PROFILE
            </PrimaryButton>
          </>
        );
      case 'REJECTED':
        return (
          <>
            <Typography variant="h6" lineHeight={1.3} textAlign="center" my={5}>
              Your <b>Bidmii Pro</b> Scholarship application was not approved at
              this time.
              <br />
              <br />
              If you’d like to be reconsidered, you’re welcome to submit a new
              application. We encourage you to review your profile and ensure
              all relevant information is up to date before reapplying.
            </Typography>

            <SecondaryButton
              style={{marginBottom: 16}}
              size="large"
              onClick={() => history.push('/my/profile/dashboard')}>
              EDIT MY PROFILE
            </SecondaryButton>

            <PrimaryButton
              size="large"
              onClick={() => history.push('/bidmii-pro/checkout')}>
              REAPPLY TO PRO
            </PrimaryButton>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <StandardDialog open hideCloseButton>
      <Grid container direction="column" alignItems="center" mt={2.5}>
        <img
          src="https://cdn.bidmii.com/media/web_assets/bidmii-pro-logo.png"
          alt="Bidmii Pro logo"
          style={{width: 200}}
        />

        {getPopupBody()}
      </Grid>
    </StandardDialog>
  );
}
